export enum Niveis {
  Crush = 5,
  Paquera = 6,
  Paixao = 7,
  Amor = 8,
  Mozao = 9,
  Embaixador = 10
}
